export default __webpack_public_path__ + "static/media/a1-4-2.7a8e0783.jpg";